const PREFIX = 'ROLE'

export const SET_ROLES = PREFIX + '.SET_ROLES'
export const APPEND_ROLES = PREFIX + '.APPEND_ROLES'
export const SET_ROLE_LIST_MANAGER = PREFIX + '.SET_ROLE_LIST_MANAGER'
export const LOAD_MORE_ROLES = PREFIX + '.LOAD_MORE_ROLES'
export const SET_ROLE_LIST_REQUEST = PREFIX + '.SET_ROLE_LIST_REQUEST'
export const SET_ROLE_LIST_REACH_BOTTOM = PREFIX + '.SET_ROLE_LIST_REACH_BOTTOM'
export const SET_LOADING_MORE_ROLE = PREFIX + '.SET_LOADING_MORE_ROLE'
